<div class="layout-shell" [class.sidebar-collapsed]="isCollapsed">
  <aside class="app-sidenav" role="navigation" aria-label="Primary">
    <div
      class="top-section"
      (click)="goHome()"
      role="button"
      tabindex="0"
      [attr.aria-label]="companyName + ' home'"
    >
      <span class="logo-pair" aria-hidden="true">
        <img
          class="logo-full"
          [src]="logoUrl || defaultLogoUrl"
          [alt]="companyName + ' home'"
        />
        <img
          class="logo-compact"
          [src]="logoCompactUrl || defaultLogoCompactUrl"
          [alt]="companyName + ' home'"
        />
      </span>
      <hr />
    </div>
    <nav class="nav-list" aria-label="Main menu">
      @for (item of navItems; track trackByNav($index, item)) {
        @if (!item.external) {
          <a
            class="nav-item"
            [routerLink]="item.route"
            [routerLinkActive]="item.route ? 'active' : ''"
            [routerLinkActiveOptions]="{ exact: true }"
            #rla="routerLinkActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [attr.aria-label]="isCollapsed ? item.label : null"
            [appSidebarFlyout]="item.label"
            [collapsed]="isCollapsed"
            [isActive]="rla.isActive"
            (click)="onNavItemClick(item, rla.isActive)"
          >
            <span
              class="nav-icon notranslate"
              [ngClass]="item.iconSet || 'material-symbols-outlined'"
              [class.icon-collapsed]="isCollapsed"
              [class.icon-expanded]="!isCollapsed"
              aria-hidden="true"
              translate="no"
              >{{ item.icon }}</span
            >
            <span
              class="nav-label"
              [class.nav-label--visible]="!isCollapsed"
              [attr.aria-hidden]="isCollapsed ? 'true' : null"
              >{{ item.label }}</span
            >
          </a>
        } @else {
          <button
            type="button"
            class="nav-item"
            (click)="openExternal(item.route)"
            [attr.aria-label]="isCollapsed ? item.label : null"
            [appSidebarFlyout]="item.label"
            [collapsed]="isCollapsed"
            [isExternal]="true"
          >
            <span
              class="nav-icon notranslate"
              [ngClass]="item.iconSet || 'material-symbols-outlined'"
              [class.icon-collapsed]="isCollapsed"
              [class.icon-expanded]="!isCollapsed"
              aria-hidden="true"
              translate="no"
              >{{ item.icon }}</span
            >
            <span
              class="nav-label"
              [class.nav-label--visible]="!isCollapsed"
              [attr.aria-hidden]="isCollapsed ? 'true' : null"
              >{{ item.label }}
              <span
                class="external-icon material-symbols-outlined notranslate"
                aria-label="Opens in new window"
                translate="no"
                >open_in_new</span
              >
            </span>
          </button>
        }
      }
      @if (canSeeAdmin) {
        <a
          class="nav-item admin-link"
          [routerLink]="'/admin'"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          #adminRla="routerLinkActive"
          [attr.aria-label]="isCollapsed ? 'Admin' : null"
          appSidebarFlyout="Admin"
          [collapsed]="isCollapsed"
          [isActive]="adminRla.isActive"
        >
          <span
            class="nav-icon material-symbols-outlined notranslate"
            aria-hidden="true"
            translate="no"
            >manage_accounts</span
          >
          <span
            class="nav-label"
            [class.nav-label--visible]="!isCollapsed"
            [attr.aria-hidden]="isCollapsed ? 'true' : null"
            >Admin</span
          >
        </a>
      }
      <a
        class="nav-item support-link"
        [href]="supportUrl"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="isCollapsed ? 'Support' : null"
        appSidebarFlyout="Support"
        [collapsed]="isCollapsed"
        [isExternal]="true"
      >
        <span
          class="nav-icon material-symbols-outlined notranslate"
          aria-hidden="true"
          translate="no"
          >help</span
        >
        <span
          class="nav-label"
          [class.nav-label--visible]="!isCollapsed"
          [attr.aria-hidden]="isCollapsed ? 'true' : null"
          >Support
          <span
            class="external-icon material-symbols-outlined notranslate"
            aria-label="Opens in new window"
            translate="no"
            >open_in_new</span
          >
          </span
        >
      </a>
    </nav>
    <div class="bottom-section">
      <button
        type="button"
        class="collapse-btn"
        (click)="toggle()"
        [attr.aria-expanded]="!isCollapsed"
        [attr.title]="isCollapsed ? 'Expand' : 'Collapse'"
        [attr.aria-label]="isCollapsed ? 'Expand' : 'Collapse'"
        [appSidebarFlyout]="isCollapsed ? 'Expand' : ''"
        [collapsed]="isCollapsed"
      >
        <span
          class="material-symbols-outlined notranslate"
          aria-hidden="true"
          translate="no"
          >{{ isCollapsed ? "left_panel_open" : "left_panel_close" }}</span
        >
        <span
          class="collapse-label"
          [class.collapse-label--visible]="!isCollapsed"
          >Collapse</span
        >
      </button>
      <div class="logo-wrapper">
        <span class="logo-pair" aria-hidden="true">
          <img
            class="logo-full"
            [src]="bottomLogoUrl || defaultBottomLogoUrl"
            [alt]="companyName + ' logo'"
          />
          <img
            class="logo-compact"
            [src]="bottomLogoCompactUrl || defaultBottomLogoCompactUrl"
            [alt]="companyName + ' logo'"
          />
        </span>
      </div>
    </div>
  </aside>
  <main class="content" [class.content--compact]="isHome" role="main">
    <ng-content />
  </main>
</div>
